import { createNode } from '@glueapp/graph-types';

export const And = createNode({
    id: 'And',
    name: 'And',
    description: 'Puts out true if both input values are true. Otherwise false',
    aiDescription:
        'Logical AND of two booleans. Connect values to "Input1" and "Input2" ports; the "Output" port returns true only if both inputs are true.',
    category: 'Logic',
    color: '#cd6205',
    integration: undefined,
    inPorts: {
        Input1: {
            kind: 'boolean',
        },
        Input2: {
            kind: 'boolean',
        },
    },
    outPorts: {
        Output: {
            kind: 'boolean',
        },
    },
    execute: function (input) {
        const inputValue1 = input.inPorts.Input1;
        const inputValue2 = input.inPorts.Input2;

        return { output: { Output: inputValue1 && inputValue2 } };
    },
});
